<template>
  <div
    class="t-grid-row"
    :class="[
      { 't-grid-row--compact': compact },
    ]"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 't-grid-row',

  props: {
    compact: Boolean,
  },
};
</script>
